import { URI_REPORT } from '@/config/config';

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;

  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const userLoginInfoResult = await fetch(
    `${URI_REPORT}reports/parking-dashboard`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.status === 'failed') {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult.data;
};
